// Mock data for NJK Logistic Pte Ltd

export const companyInfo = {
  name: "NJK Logistic Pte Ltd",
  tagline: "Swift, Secure and Reliable",
  logo: "https://customer-assets.emergentagent.com/job_193da88a-38a6-4eb7-b1f4-1a973cc5c4bb/artifacts/wfxsnfmd_image.png",
  address: "212A Punggol Walk #12-741 Singapore 821212",
  phone: "98366186",
  paynow: "UEN: 202606027K",
  email: "inquiry@njklogistics.com",
  experience: "10+"
};

export const services = [
  {
    id: 1,
    name: "Lorry Crane",
    description: "Heavy-duty lorry cranes for lifting and transportation needs",
    icon: "crane",
    capacity: "25 - 100 Ton",
    details: [
      "25 Ton Lorry Crane",
      "40 Ton Lorry Crane",
      "60 Ton Lorry Crane",
      "80 Ton Lorry Crane",
      "100 Ton Lorry Crane"
    ],
    features: [
      "Professional operators included",
      "Latest safety equipment",
      "Regular maintenance",
      "Insurance coverage"
    ]
  },
  {
    id: 2,
    name: "Tailgate Box Lorry",
    description: "Reliable tailgate lorries for efficient cargo transportation",
    icon: "truck",
    capacity: "14ft & 24ft",
    details: [
      "14ft Tailgate Box Lorry",
      "24ft Tailgate Box Lorry"
    ],
    features: [
      "Easy loading/unloading",
      "Weather-protected cargo area",
      "Experienced drivers",
      "Flexible scheduling"
    ]
  },
  {
    id: 3,
    name: "Trailer",
    description: "Various trailer options for your heavy cargo needs",
    icon: "container",
    capacity: "Various Sizes",
    details: [
      "Flatbed Trailers",
      "Low-bed Trailers",
      "Container Trailers"
    ],
    features: [
      "Heavy load capacity",
      "Long-distance capable",
      "GPS tracking",
      "24/7 availability"
    ]
  },
  {
    id: 4,
    name: "Manpower",
    description: "Skilled and reliable manpower for your logistics operations",
    icon: "users",
    capacity: "On-Demand",
    details: [
      "Loading/Unloading crew",
      "Warehouse staff",
      "Rigging specialists",
      "Site supervisors"
    ],
    features: [
      "Trained professionals",
      "Safety certified",
      "Flexible team sizes",
      "Short notice availability"
    ]
  },
  {
    id: 5,
    name: "Warehouse Storage",
    description: "Secure warehouse storage and handling services for your cargo",
    icon: "warehouse",
    capacity: "Flexible",
    details: [
      "Short-term storage",
      "Long-term storage",
      "Handling services",
      "Inventory management"
    ],
    features: [
      "Secure facility",
      "Loading/Unloading handling",
      "Flexible storage periods",
      "Easy access"
    ]
  }
];

export const whyChooseUs = [
  {
    title: "10+ Years Experience",
    description: "Decade of expertise in heavy vehicle logistics and crane operations",
    icon: "award"
  },
  {
    title: "Professional Team",
    description: "Certified operators and experienced crew for all operations",
    icon: "users-2"
  },
  {
    title: "Modern Fleet",
    description: "Well-maintained equipment with latest safety features",
    icon: "truck"
  },
  {
    title: "24/7 Support",
    description: "Round-the-clock customer service and emergency assistance",
    icon: "clock"
  },
  {
    title: "Competitive Pricing",
    description: "Fair and transparent pricing with no hidden costs",
    icon: "dollar-sign"
  },
  {
    title: "Safety First",
    description: "Strict safety protocols and comprehensive insurance coverage",
    icon: "shield-check"
  }
];

export const stats = [
  { label: "Years of Experience", value: "10+" },
  { label: "Projects Completed", value: "500+" },
  { label: "Trusted Partners", value: "10+" }
];

export const testimonials = [
  {
    id: 1,
    name: "John Lim",
    company: "",
    text: "NJK Logistics has been our go-to partner for all crane services. Professional, reliable, and always on time!",
    rating: 5
  },
  {
    id: 2,
    name: "Sarah Tan",
    company: "",
    text: "Excellent service! The team is professional and the equipment is always in top condition. Highly recommended.",
    rating: 5
  },
  {
    id: 3,
    name: "David Wong",
    company: "",
    text: "We've worked with NJK for the past 9 months. Their expertise and commitment to safety is unmatched.",
    rating: 5
  }
];